import type { ReportsMessageId } from "./reports.fr";

/** Signalements in Spanish. Same keys and {placeholders} as reports.fr.ts. */
export const reportsEs: Record<ReportsMessageId, string> = {
  "reports.filter.severity": "Gravedad",
  "reports.filter.status": "Estado",
  "reports.filter.all": "Todos",
  "reports.filter.reviewOverdue": "Revisión de suspensión atrasada",
  "reports.list.loading": "Cargando las denuncias…",
  "reports.list.loadFailed": "No se pudieron cargar las denuncias.",
  "reports.list.empty": "No hay denuncias con estos filtros.",
  "reports.list.aria": "Denuncias",
  "reports.list.by": "denunciado por {name}",
  "reports.list.aboutSubject": "{count} denuncias sobre esta persona",
  "reports.pick": "Elija una denuncia de la lista.",
  "reports.loading": "Cargando la denuncia…",
  "reports.loadFailed": "No se pudo cargar esta denuncia.",
  "reports.notFound": "No se encuentra esta denuncia. Vuelva a cargar la lista.",
  "reports.refreshFailed": "No se pudo actualizar la denuncia: se muestra tal como estaba.",
  "reports.dismiss": "Cerrar",

  "reports.severity.critical": "Crítica",
  "reports.severity.high": "Alta",
  "reports.severity.medium": "Media",
  "reports.severity.low": "Baja",
  "reports.status.open": "Abierta",
  "reports.status.investigating": "En investigación",
  "reports.status.decided": "Resuelta",
  "reports.status.appealed": "En apelación",
  "reports.status.closed": "Cerrada",
  "reports.verdict.none": "Sin sanción",
  "reports.verdict.warning": "Advertencia",
  "reports.verdict.temporary_suspension": "Suspensión temporal",
  "reports.verdict.permanent_ban": "Expulsión definitiva",
  "reports.appeal.upheld": "Decisión mantenida",
  "reports.appeal.overturned": "Decisión anulada",
  "reports.source.app": "Desde la aplicación",
  "reports.source.phone": "Por teléfono",
  "reports.source.console": "Abierta por el equipo",

  "reports.category.assault": "Agresión",

  "reports.new.title": "Nueva denuncia",

  "reports.new.source": "Cómo nos llegó",

  "reports.new.byPhone": "Por teléfono",

  "reports.new.byStaff": "Detectado por el equipo",

  "reports.new.subject": "A quién se denuncia",

  "reports.new.reporter": "Quién lo denunció",

  "reports.new.reporterHint": "Su identificador, si lo denunció un cliente. Déjelo vacío si lo detectó el equipo.",

  "reports.new.category": "Qué ocurrió",

  "reports.new.categoryHint": "La gravedad se deriva de esto. Puede cambiarla después.",

  "reports.new.description": "Lo que nos contaron",

  "reports.new.descriptionHint": "Con sus palabras cuando sea posible. Lo leerá quien investigue.",

  "reports.new.submit": "Abrir la denuncia",

  "reports.new.needSubject": "Elija a quién se denuncia.",

  "reports.new.needDescription": "Describa qué ocurrió, al menos en una frase.",

  "reports.new": "Nueva denuncia",
  "reports.category.sexual_violence": "Violencia sexual",
  "reports.category.serious_theft": "Robo grave",
  "reports.category.weapon_threat": "Amenaza con arma",
  "reports.category.theft": "Robo",
  "reports.category.threats": "Amenazas",
  "reports.category.harassment": "Acoso",
  "reports.category.fraud": "Estafa",
  "reports.category.unsafe_work": "Trabajo peligroso",
  "reports.category.no_show": "No se presentó a la cita",
  "reports.category.other": "Otro",

  "reports.pill.suspended": "Suspendido",
  "reports.pill.reviewOverdue": "Revisión atrasada",
  "reports.pill.legalHold": "Retención legal",

  "reports.detail.versionTitle": "La versión de la denuncia mostrada: cada acción la envía.",
  "reports.detail.critical": "Denuncia crítica",
  "reports.detail.needsPolice": "Aún no se ha remitido a la policía. Se ha avisado a los propietarios.",
  "reports.detail.subject": "Persona denunciada",
  "reports.detail.reporter": "Autor de la denuncia",
  "reports.detail.openedBy": "Abierta por {name}",
  "reports.detail.noReporter": "Desconocido",
  "reports.detail.job": "Solicitud relacionada",
  "reports.detail.case": "Expediente de origen",
  "reports.detail.subjectCase": "Expediente de la persona denunciada",
  "reports.detail.openCase": "Abrir el expediente →",
  "reports.detail.noSubjectCase": "Ninguno: se abre con la suspensión o la apelación",
  "reports.detail.none": "Ninguno",
  "reports.detail.description": "Lo que pasó",
  "reports.detail.restrictions": "Suspensiones y expulsiones",
  "reports.detail.restrictionsHint":
    "Una suspensión dura hasta una decisión del equipo. El plazo de revisión no es un final: pasado ese plazo, la persona sigue suspendida y la revisión está atrasada.",
  "reports.detail.verdict": "Veredicto",
  "reports.detail.decidedBy": "Por {name}, el {date}",
  "reports.detail.appeal": "Apelación",
  "reports.detail.appealedAt": "Apelación recibida el {date}",
  "reports.detail.appealPending": "Por resolver",
  "reports.detail.police": "Remisiones a la policía",
  "reports.detail.shared": "Datos entregados: {categories} · {name}, {date}",
  "reports.detail.holds": "Retenciones legales",
  "reports.detail.holdPlaced": "Vigente desde el {date} · {name}",
  "reports.detail.holdReleased": "Levantada el {date} · {name}",
  "reports.detail.related": "Otras denuncias sobre esta persona",
  "reports.detail.timeline": "Cronología",
  "reports.detail.actions": "Acciones",
  "reports.detail.noActions": "Sus roles no permiten ninguna acción sobre esta denuncia.",

  "reports.restriction.interim_suspension": "Suspensión durante la investigación",
  "reports.restriction.temporary_suspension": "Suspensión temporal",
  "reports.restriction.permanent_ban": "Expulsión definitiva",
  "reports.restriction.untilDecision": "Hasta una decisión del equipo",
  "reports.restriction.untilDecisionReviewBy": "Hasta una decisión del equipo · revisar antes del {date}",
  "reports.restriction.until": "Hasta el {date}",
  "reports.restriction.permanent": "Definitiva, salvo apelación aceptada",
  "reports.restriction.switchedOff": "Desactivado: {features}",
  "reports.restriction.lifted": "Levantada el {date} por {name}",
  "reports.restriction.inForce": "Vigente",
  "reports.restriction.ended": "Terminada",

  "reports.entry.report": "Denuncia",
  "reports.entry.evidence": "Prueba",
  "reports.entry.severity_changed": "Gravedad cambiada",
  "reports.entry.suspended": "Suspensión aplicada",
  "reports.entry.suspension_lifted": "Suspensión levantada",
  "reports.entry.verdict": "Veredicto",
  "reports.entry.appeal": "Apelación",
  "reports.entry.appeal_decided": "Apelación resuelta",
  "reports.entry.police_referral": "Remitida a la policía",
  "reports.entry.police_data_shared": "Datos entregados a la policía",
  "reports.entry.legal_hold_placed": "Retención legal aplicada",
  "reports.entry.legal_hold_released": "Retención legal levantada",
  "reports.entry.linked": "Enlace añadido",
  "reports.entry.suspension_withheld": "Suspensión no aplicada",
  "reports.entry.system": "Sistema",
  "reports.entry.evidenceLink": "Ver la prueba →",

  "reports.police.category.identity": "Identidad",
  "reports.police.category.contact_details": "Datos de contacto",
  "reports.police.category.id_document": "Documento de identidad",
  "reports.police.category.messages": "Mensajes",
  "reports.police.category.job_details": "Detalles de la solicitud",
  "reports.police.category.report_and_evidence": "Denuncia y pruebas",
  "reports.police.category.audit_log": "Registro de auditoría",
  "reports.police.category.payments": "Pagos",
  "reports.hold.entity.safety_report": "Esta denuncia",
  "reports.hold.entity.user": "La cuenta",
  "reports.hold.entity.job": "La solicitud",
  "reports.hold.entity.conversation": "La conversación",

  "reports.block.ownVerdict": "Usted dictó el veredicto: otra persona debe resolver la apelación.",
  "reports.block.ownerOnly": "Solo un propietario puede entregar datos a la policía.",
  "reports.block.noReferral": "Remita primero la denuncia a la policía para anotar los datos entregados.",

  "reports.action.evidence": "Añadir una prueba",
  "reports.action.severity": "Cambiar la gravedad",
  "reports.action.suspend": "Suspender durante la investigación",
  "reports.action.lift": "Levantar la suspensión",
  "reports.action.verdict": "Dictar el veredicto",
  "reports.action.ban": "Expulsar definitivamente",
  "reports.action.appeal": "Resolver la apelación",
  "reports.action.police": "Remitir a la policía",
  "reports.action.share": "Anotar datos entregados",
  "reports.action.hold": "Aplicar una retención legal",
  "reports.action.release": "Levantar la retención legal",

  "reports.dialog.evidence.title": "Añadir una prueba · {reference}",
  "reports.dialog.evidence.body":
    "Describa la prueba y, si está en línea, indique su enlace. Se añade a la cronología.",
  "reports.dialog.severity.title": "Cambiar la gravedad · {reference}",
  "reports.dialog.severity.body":
    "Una denuncia crítica avisa a los propietarios y debe remitirse a la policía. Indique por qué la cambia.",
  "reports.dialog.suspend.title": "Suspender · {reference}",
  "reports.dialog.suspend.body":
    "{name} no podrá usar Walliyo, salvo para contactar con el equipo y apelar, hasta una decisión del equipo. Se aplica un plazo de revisión: no es el final de la suspensión. La persona recibe el aviso en la aplicación y se abre un expediente a su nombre.",
  "reports.dialog.lift.title": "Levantar la suspensión · {reference}",
  "reports.dialog.lift.body": "{name} recupera el acceso a Walliyo desde ahora. Indique por qué.",
  "reports.dialog.verdict.title": "Dictar el veredicto · {reference}",
  "reports.dialog.verdict.body":
    "{name} lee el motivo en la aplicación y puede apelar una vez. Nadie recibe una sanción sin un motivo escrito.",
  "reports.dialog.ban.title": "Expulsar definitivamente · {reference}",
  "reports.dialog.ban.body":
    "{name} pierde el acceso a Walliyo para siempre y su documento de identidad queda vetado. Se le muestra el motivo en la aplicación; puede apelar una vez.",
  "reports.dialog.appeal.title": "Resolver la apelación · {reference}",
  "reports.dialog.appeal.body":
    "Anulada levanta lo que aplicó el veredicto. {name} lee su motivo en la aplicación. Debe resolverla alguien distinto del autor del veredicto.",
  "reports.dialog.police.title": "Remitir a la policía · {reference}",
  "reports.dialog.police.body": "Anote a quién se remitió la denuncia. Desde aquí no se envía nada.",
  "reports.dialog.share.title": "Datos entregados a la policía · {reference}",
  "reports.dialog.share.body":
    "Anote exactamente lo que se entregó, categoría por categoría. Este rastro se conserva y figura en el registro de auditoría.",
  "reports.dialog.hold.title": "Aplicar una retención legal · {reference}",
  "reports.dialog.hold.body":
    "Nada relacionado con esta denuncia podrá borrarse mientras la retención esté vigente, ni siquiera por la regla de conservación.",
  "reports.dialog.release.title": "Levantar la retención legal · {reference}",
  "reports.dialog.release.body": "Las reglas de conservación vuelven a aplicarse a todo lo que protegía la retención.",

  "reports.field.evidence": "La prueba",
  "reports.field.evidenceUrl": "Enlace (opcional)",
  "reports.field.evidenceUrlHint": "Una dirección https://, por ejemplo una foto subida al expediente.",
  "reports.field.severity": "Nueva gravedad",
  "reports.field.verdict": "Veredicto",
  "reports.field.suspendedUntil": "Suspendido hasta el",
  "reports.field.toldReason": "Motivo que lee la persona",
  "reports.field.toldHint": "Una frase real, con palabras que la persona entienda. Al menos 10 caracteres.",
  "reports.field.decision": "Decisión",
  "reports.field.station": "Comisaría o brigada",
  "reports.field.officerName": "Nombre del agente",
  "reports.field.officerContact": "Contacto del agente (opcional)",
  "reports.field.policeReference": "Referencia de la policía (opcional)",
  "reports.field.referral": "Remisión",
  "reports.field.categories": "Datos entregados",
  "reports.field.shareDescription": "Lo que se entregó, exactamente",
  "reports.field.shareDescriptionHint": "Por ejemplo: mensajes del 3 al 5 de mayo, escaneo del documento de identidad.",
  "reports.field.reasonOptional": "Motivo (opcional)",

  "reports.problem.reason": "Indique un motivo de {min} a {max} caracteres.",
  "reports.problem.told": "Escriba el motivo que leerá la persona: al menos {min} caracteres.",
  "reports.problem.evidence": "Describa la prueba.",
  "reports.problem.url": "El enlace debe ser una dirección http:// o https:// completa.",
  "reports.problem.until": "Elija una fecha de fin de suspensión en el futuro.",
  "reports.problem.police": "Indique la comisaría y el nombre del agente (de 2 a 200 caracteres cada uno).",
  "reports.problem.referral": "Elija la remisión correspondiente.",
  "reports.problem.categories": "Marque al menos una categoría de datos entregados.",
  "reports.problem.shareDescription": "Indique exactamente lo que se entregó.",

  "reports.done.evidence": "Prueba añadida a {reference}.",
  "reports.done.severity": "Gravedad de {reference} cambiada.",
  "reports.done.suspend":
    "Persona suspendida hasta una decisión del equipo ({reference}). Recibe el aviso en la aplicación.",
  "reports.done.lift": "Suspensión levantada ({reference}).",
  "reports.done.verdict": "Veredicto guardado en {reference}. La persona recibe el aviso en la aplicación.",
  "reports.done.ban": "Expulsión guardada en {reference}. La persona recibe el aviso en la aplicación.",
  "reports.done.appeal": "Apelación resuelta en {reference}. La persona recibe el aviso en la aplicación.",
  "reports.done.police": "Remisión a la policía anotada en {reference}.",
  "reports.done.share": "Datos entregados anotados en {reference}.",
  "reports.done.hold": "Retención legal aplicada a {reference}.",
  "reports.done.release": "Retención legal levantada en {reference}.",

  "reports.error.stale": "Esta denuncia cambió mientras la miraba. Vuelva a cargarla, compruébela y empiece de nuevo.",
  "reports.error.refused":
    "Acción rechazada: sus roles no incluyen la función necesaria. Pida acceso a un responsable.",
  "reports.error.appealRefused":
    "Rechazado: la apelación debe resolverla alguien distinto del autor del veredicto, con HANDLE_APPEALS.",
  "reports.error.shareRefused": "Rechazado: solo un propietario puede entregar datos a la policía.",
  "reports.error.invalid":
    "Rechazado: la denuncia ya no está en el estado esperado, o un campo no es válido. Vuelva a cargarla y compruébela.",
  "reports.error.outcomeUnknown":
    "Sin respuesta del servidor: puede que la acción se haya guardado. Inténtelo de nuevo: el mismo clic no puede aplicarse dos veces.",

  "reports.refused.wrongStatus":
    "Rechazado: esta denuncia ya no está en ese paso, la acción ya no aplica. Vuelva a cargarla.",
  "reports.refused.alreadyRestricted": "Rechazado: esta persona ya está suspendida por otra denuncia.",
  "reports.refused.notSuspended":
    "Rechazado: esta denuncia ya no tiene ninguna suspensión en vigor. Vuelva a cargarla.",
  "reports.refused.suspendedUntilRequired": "Una suspensión temporal necesita una fecha de fin en el futuro.",
  "reports.refused.ownVerdict":
    "Rechazado: usted dictó este veredicto, así que otra persona debe resolver la apelación.",
  "reports.refused.alreadyHeld": "Esta denuncia ya está bajo retención legal. Vuelva a cargarla.",
  "reports.refused.notHeld": "Esta denuncia ya no está bajo retención legal. Vuelva a cargarla.",
};
